import { render, staticRenderFns } from "./multiple_kakuzais_field.vue?vue&type=template&id=cffb4d30&scoped=true&lang=pug&"
import script from "./multiple_kakuzais_field.vue?vue&type=script&lang=js&"
export * from "./multiple_kakuzais_field.vue?vue&type=script&lang=js&"
import style0 from "./multiple_kakuzais_field.vue?vue&type=style&index=0&id=cffb4d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb4d30",
  null
  
)

export default component.exports